var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query-auth-history"},[_c('query-form',{attrs:{"config":['串号', '操作类型', '创建时间', '产品名称', '生产者账号']},on:{"fetch-data":_vm.fetchData}}),_c('count-total',{attrs:{"total":_vm.total}}),_c('my-list',{attrs:{"dataSource":_vm.dataSource,"loading":_vm.loading,"flag":_vm.flag,"search":_vm.search}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }